<template>
  <v-form v-model="isFormValid" ref="form">
    <div>
      <dashboard-header :text="item ? $t('ui.updateGroup'): $t('ui.createGroup')" :on-back="onGoBack"/>
      <div class="d-flex justify-center align-center">
        <v-card elevation="0"
                class="card-border-10 w-75">
          <v-card class="m-4"
                  outlined>
            <div class="d-flex custom-card-head p-4">
              <div class="d-inline text-sm-h5 ">{{ $t("nav.about") }}</div>
            </div>
            <v-divider class="m-0"></v-divider>
            <div class="px-6 pt-6">
              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('ui.nameGroup') }}</p>
              </div>
              <v-textarea
                  v-model="group.name"
                  :rules="ruleGroupName"
                  :placeholder="placeholderName"
                  counter="100"
                  rows="1"
                  auto-grow
                  outlined
              >
              </v-textarea>
              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('ui.dutyDepartment') }}</p>
              </div>

              <!-- Chips display above select -->
              <div v-if="selectedTargets && selectedTargets.length > 0" class="chips-container">
                <v-chip
                  v-for="item in selectedTargets"
                  :key="item.departmentId"
                  class="custom-chip-employee"
                >
                  <span class="chip-text ellipsis-one-line">{{ item.name }}</span>
                  <v-icon class="chip-close" small color="grey" @click="removeChip(item)">mdi-close</v-icon>
                </v-chip>
              </div>

              <v-select
                  v-model="selectedTargets"
                  :items="listTargets"
                  :placeholder="$t('group.selectDepartment')"
                  :rules="ruleSelectDepartment"
                  item-text="name"
                  chips
                  multiple
                  deletable-chips
                  return-object
                  dense
                  outlined
                  class="group-select-with-chips"
                  :menu-props="menuProps"
                  ref="departmentSelect">
                  <template v-slot:selection="{ index }">
                    <span v-if="index === 0" class="selection-placeholder">{{ $t('group.selectDepartment') }}</span>
                  </template>
              </v-select>
            </div>
          </v-card>
          <div class=" m-4">
            <v-btn
                elevation="0"
                class="no-uppercase btn-custom-primary"
                :disabled="!isFormValid"
                @click="onSave"
            >{{ $t('ui.save') }}
            </v-btn>
          </div>
        </v-card>
      </div>
    </div>

  </v-form>

</template>

<script>
import DashboardHeader from "../component/DashboardHeader";
import {API2} from "../../api";
import mixin from "../../mixin";

export default {
  name: "CreateOrUpdate",
  components: {DashboardHeader},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    }
  },
  data() {
    return {
      group: this.getDefaultGroup(),
      listTargets: [],
      selectedTargets: null,
      isFormValid: false,
      selectWidth: null,
    }
  },
  mounted() {
    this.onTab(this.item)
    this.$nextTick(() => {
      this.calculateSelectWidth()
    })
  },
  computed: {
    ruleGroupName() {
      return [
        this.group.name.length > 0 && this.group.name.length <= 100 || this.$t("ui.MSG0101"),
        this.group.name.trim().length > 0 || this.$t("ui.MSG0101")
      ]
    },
    ruleSelectDepartment() {
      return [
        !!this.selectedTargets && this.selectedTargets.length > 0 || this.$t('group.departmentValidate')
      ]
    },
    placeholderName() {
      return this.$t('ui.enterNameGroup')
    },
    menuProps() {
      return {
        offsetY: true,
        nudgeBottom: 4,
        contentClass: 'department-dropdown-menu',
        maxWidth: this.selectWidth || 'auto',
        minWidth: this.selectWidth || 'auto'
      }
    }
  },
  methods: {
    onGoBack() {
      this.openTab(0)
    },
    onTab(item) {
      this.$refs.form.resetValidation()
      this.selectedTargets = null
      this.getlistFilterTable();
      this.group = this.getDefaultGroup()
      if (item) this.getData(item)
    },
    getDefaultGroup() {
      return {
        name: ''
      }
    },
    async getData(item) {
      let res = await this.get(API2.GROUP, {path: item.data.groupId})
      if (res) {
        this.group = res
      } else {
        // No data found, go back to previous screen
        this.onGoBack();
      }
    },
    async getlistFilterTable() {
      let res = await this.get(API2.DEPARTMENT)
      if (res) {
        this.listTargets = res.data || [];
        if (this.item) {
          this.selectedTargets = this.listTargets.filter(
              value => this.item.data.departmentIds.includes(value.departmentId)
          );
          if (!this.selectedTargets) this.selectedTargets = this.listTargets[0];
        }
        // Recalculate width after data loads
        this.$nextTick(() => {
          this.calculateSelectWidth()
        })
      }
    },
    async onSave() {
      let data = {
        name: this.group.name,
        departmentIds: this.selectedTargets.map(value => value.departmentId)
      }
      if (this.item) data.path = this.group.groupId
      let res = this.item ? await this.put(API2.GROUP, data) : await this.post(API2.GROUP, data)
      if (!res) return
      this.showToast("success", this.$t('ui.toastSuccess'), '')
      this.openTab(0)
    },
    removeChip(item) {
      const index = this.selectedTargets.findIndex(target => target.departmentId === item.departmentId)
      if (index >= 0) {
        this.selectedTargets.splice(index, 1)
      }
    },
    calculateSelectWidth() {
      this.$nextTick(() => {
        if (this.$refs.departmentSelect && this.$refs.departmentSelect.$el) {
          const selectElement = this.$refs.departmentSelect.$el.querySelector('.v-input__control')
          if (selectElement) {
            this.selectWidth = selectElement.offsetWidth + 'px'
          }
        }
      })
    },
  },
}
</script>

<style scoped>

.v-input {
  font-size: 22px;
}

.card-border-10 >>> .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: rgba(217, 217, 217, 1);
}

.ellipsis-one-line {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* Chips container */
.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  margin: 4px 0 12px 0; /* spacing above and below chips */
}

/* Copy exact styling from permission module - custom-chip-employee */
.custom-chip-employee {
  border: 1px solid #D9D9D9 !important;
  border-radius: 2px;
  background-color: #FAFAFA !important;
}

/* Select field styling */
.group-select-with-chips {
  margin-top: 0;
  margin-bottom: 24px;
}

/* Dropdown menu styling - width same as select field */
.group-select-with-chips >>> .v-menu__content {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid #e0e0e0 !important;
  overflow: hidden !important;
}

/* Alternative approach using contentClass */
.department-dropdown-menu {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid #e0e0e0 !important;
  overflow: hidden !important;
}

/* Force exact width match */
.department-dropdown-menu .v-list {
  padding: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
}

/* Dropdown list items styling */
.group-select-with-chips >>> .v-list-item,
.department-dropdown-menu .v-list-item {
  padding: 12px 16px !important;
  min-height: 48px !important;
  border-bottom: 1px solid #f5f5f5;
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
}

.group-select-with-chips >>> .v-list-item:last-child,
.department-dropdown-menu .v-list-item:last-child {
  border-bottom: none;
}

.group-select-with-chips >>> .v-list-item:hover,
.department-dropdown-menu .v-list-item:hover {
  background-color: #f0f8ff !important;
}

.group-select-with-chips >>> .v-list-item--active,
.department-dropdown-menu .v-list-item--active {
  background-color: #e6f7ff !important;
  color: #1890ff !important;
}

/* Dropdown text styling - truncate long text */
.group-select-with-chips >>> .v-list-item__title,
.department-dropdown-menu .v-list-item__title {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #333 !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
  max-width: 100% !important;
  display: block !important;
}

.group-select-with-chips >>> .v-list-item--active .v-list-item__title,
.department-dropdown-menu .v-list-item--active .v-list-item__title {
  color: #1890ff !important;
  font-weight: 500 !important;
}

/* Ensure chip content is single line with ellipsis and smaller close icon */
.custom-chip-employee >>> .v-chip__content {
  display: flex;
  align-items: center;
  max-width: 100%;
}
.custom-chip-employee .chip-text {
  flex: 1 1 auto;
  min-width: 0; /* allow flex child to shrink for ellipsis */
}
.custom-chip-employee .chip-close {
  margin-left: 4px;
}



/* Prevent clipping of Vietnamese diacritics inside v-select */
.group-select-with-chips >>> .v-input__slot {
  overflow: visible !important;
}
.group-select-with-chips >>> .v-select__selections {
  overflow: visible !important;
  line-height: 30px !important; /* ensure enough room for dấu nặng */
}


/* Ensure no unwanted capitalization and avoid clipping diacritics in selection area */
.group-select-with-chips >>> .v-select__selections {
  text-transform: none !important;
}

.selection-placeholder {
  color: rgba(0, 0, 0, 0.38);
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-transform: none !important;
  line-height: 28px; /* give more room for diacritics below baseline */
  position: relative;
  top: -1px; /* nudge up a bit to prevent bottom clipping */
}



</style>